import React from 'react';
import PropTypes from 'prop-types';

export const ScoreCard = ({ title, value, color, formatter }) => {
  return (
    <div className="score-card">
      <p className="score-card__title" title={title}>
        {title}
      </p>
      <p className="score-card__value" title={value} style={{ color }}>
        {formatter ? formatter(value) : value}
      </p>
    </div>
  );
};

ScoreCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  formatter: PropTypes.func,
};
